
import list from '../../demand/creative-list/index';
export default {
  components: {
    list: list
  },

  data: function data() {
    return {};
  },
  mounted: function mounted() {},


  methods: {}
};